import { useQuery } from '@tanstack/react-query'
import { Helmet } from 'react-helmet-async'
import { api } from '@/services/api'

const AdminPage = () => {
  const { data: stats, isLoading } = useQuery({
    queryKey: ['admin', 'stats'],
    queryFn: async () => {
      const response = await api.get('/admin/stats')
      return response.data
    },
  })

  if (isLoading) {
    return <div className="loading">Chargement...</div>
  }

  return (
    <div>
      <Helmet>
        <title>Administration - EdenPlaisir.com</title>
        <meta name="description" content="Panneau d'administration" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <h1>Administration</h1>
      
      {stats && (
        <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))' }}>
          <div className="card">
            <h3>Statistiques générales</h3>
            <p><strong>Utilisateurs:</strong> {stats.totalUsers}</p>
            <p><strong>Contenus:</strong> {stats.totalContents}</p>
            <p><strong>En attente:</strong> {stats.pendingContents}</p>
            <p><strong>Approuvés:</strong> {stats.approvedContents}</p>
            <p><strong>Rejetés:</strong> {stats.rejectedContents}</p>
          </div>

          <div className="card">
            <h3>Activité récente</h3>
            <p><strong>Uploads aujourd'hui:</strong> {stats.uploadsToday}</p>
            <p><strong>Connexions aujourd'hui:</strong> {stats.loginsToday}</p>
            <p><strong>Signalements:</strong> {stats.totalReports}</p>
            <p><strong>Paiements:</strong> {stats.totalPayments}</p>
          </div>

          <div className="card">
            <h3>Stockage</h3>
            <p><strong>Espace utilisé:</strong> {stats.storageUsed} GB</p>
            <p><strong>Fichiers:</strong> {stats.totalFiles}</p>
            <p><strong>Vidéos HLS:</strong> {stats.hlsVideos}</p>
          </div>
        </div>
      )}

      <div className="card" style={{ marginTop: '2rem' }}>
        <h3>Actions d'administration</h3>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <button className="btn-primary">
            Générer les sitemaps
          </button>
          <button className="btn-primary">
            Nettoyer le cache
          </button>
          <button className="btn-primary">
            Exporter les logs
          </button>
          <button className="btn-secondary">
            Redémarrer les workers
          </button>
        </div>
      </div>

      <div className="card" style={{ marginTop: '2rem' }}>
        <h3>Configuration système</h3>
        <div style={{ color: '#ccc' }}>
          <p><strong>Environnement:</strong> {import.meta.env.MODE}</p>
          <p><strong>Version API:</strong> 1.0.0</p>
          <p><strong>Base de données:</strong> PostgreSQL 16</p>
          <p><strong>Stockage:</strong> MinIO S3</p>
          <p><strong>Queue:</strong> Doctrine Transport</p>
        </div>
      </div>
    </div>
  )
}

export default AdminPage
